import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Global from 'constants/Global';

class BreakpointChecker {
  constructor(breakpoints) {
    this.breakpoints = breakpoints;

    window.addEventListener('resize', this.checkBreakpoints);

    this.currentBreakpoint = null;
    this.checkBreakpoints();
  }

  checkBreakpoints = () => {
    let newBreakpoint;
    const width = window.innerWidth;

    const breakpointActivity = Object.entries(this.breakpoints).reduce(
      (ranges, breakpoint) => {
        const [key, data] = breakpoint;

        const breakpointIsActive =
          width >= data.lowerbound && width <= data.upperbound;
        ranges[`breakpointIs${key}`] = breakpointIsActive;

        if (breakpointIsActive) newBreakpoint = key;

        return ranges;
      },
      {}
    );

    if (this.currentBreakpoint !== newBreakpoint) {
      this.currentBreakpoint = newBreakpoint;

      this.breakpointData = {
        currentBreakpoint: this.currentBreakpoint,
        ...breakpointActivity
      };

      const changeEvent = new CustomEvent('breakpointChange', {
        detail: this.breakpointData
      });

      return window.dispatchEvent(changeEvent);
    }
  };

  getBreakpointData = () => this.breakpointData;
}

const Breakpoints = new BreakpointChecker(Global.breakpoints);
window.Breakpoints = Breakpoints;

const withBreakpoint = WrappedComponent => {
  class WithBreakpoint extends Component {
    static breakpointDataTypes = {
      currentBreakpoint: PropTypes.string,

      ...Object.keys(Global.breakpoints).reduce((ranges, breakpoint) => {
        ranges[`breakpointIs${breakpoint}`] = PropTypes.bool;
        return ranges;
      }, {})
    };

    state = {
      breakpointData: Breakpoints.getBreakpointData()
    };

    componentDidMount() {
      window.addEventListener('breakpointChange', this.updateBreakpoints);
    }

    componentWillUnmount() {
      window.removeEventListener('breakpointChange', this.updateBreakpoints);
    }

    updateBreakpoints = e => {
      this.setState({ breakpointData: e.detail });
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          breakpointData={this.state.breakpointData}
        />
      );
    }
  }

  return WithBreakpoint;
};

export default withBreakpoint;
